import { render } from "./VideoPlayer.vue?vue&type=template&id=167565a4&scoped=true&ts=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=167565a4&scoped=true&lang=css"
import "./VideoPlayer.vue?vue&type=style&index=1&id=167565a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167565a4"]])

export default __exports__